import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { consumePostOAuthReturnPath } from '../utils/postOAuthReturn';

interface UsePostOAuthReturnRedirectParams {
  skip?: boolean;
}

function extractPathname(path: string): string {
  const [pathname] = path.split('?');
  return pathname;
}

export function usePostOAuthReturnRedirect({
  skip = false,
}: UsePostOAuthReturnRedirectParams = {}): void {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (skip) {
      return;
    }

    const returnPath = consumePostOAuthReturnPath();
    if (!returnPath) {
      return;
    }

    if (extractPathname(returnPath) === location.pathname) {
      return;
    }

    navigate(returnPath, { replace: true });
  }, [skip]);
}
